import { useNavigate } from "react-router-dom";
import React, { useState } from 'react';
import {ethers} from "ethers";

function LoginForm() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');
    const navigate = useNavigate();

    const login = async () => {
        const res = await fetch('/api/auth/login', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ username, password })
        });

        if (res.ok) {
            const data = await res.json();
            localStorage.setItem('token', data.token);
            setMessage("Login successful!");
            navigate("/dashboard"); // ✅ Navigate after login
        } else {
            setMessage("Unauthorized");
        }
    };

    const loginWithWallet = async () => {
        if (!window.ethereum) return alert("Wallet not found");

        const provider = new ethers.BrowserProvider(window.ethereum);
        const signer = await provider.getSigner();
        const address = await signer.getAddress();

        const message = `Login request for ${address}`;
        const signature = await signer.signMessage(message);

        const res = await fetch('/api/auth/wallet-login', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ message, signature })
        });

        if (res.ok) {
            const data = await res.json();
            localStorage.setItem('token', data.token);
            alert("Logged in with wallet!");
        } else {
            alert("Unauthorized");
        }
    };

    // const checkAuthorization = async () => {
    //     const token = localStorage.getItem('token');
    //     const res = await fetch('http://localhost:8080/api/protected', {
    //         headers: {
    //             'Authorization': `Bearer ${token}`
    //         }
    //     });
    //
    //     if (res.ok) {
    //         console.log("Authorized");
    //     } else {
    //         console.log("Not Authorized");
    //     }
    // };


    return (
        // <div>
        //     <h2>Login</h2>
        //     <input placeholder="Username" value={username} onChange={e => setUsername(e.target.value)} />
        //     <input placeholder="Password" type="password" value={password} onChange={e => setPassword(e.target.value)} />
        //     <button onClick={login}>Login</button>
        //     <p>{message}</p>
        // </div>

        <div className="min-h-screen flex items-center justify-center bg-gray-100">
            <div className="w-full max-w-md p-6 bg-white rounded shadow-md">
                <h2 className="text-3xl font-bold mb-6 text-center">Login</h2>
                <div className="mb-4">
                    <input
                        type="text"
                        placeholder="Username"
                        value={username}
                        onChange={e => setUsername(e.target.value)}
                        className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                </div>
                <div className="mb-6">
                    <input
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                        className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                </div>
                <div className="flex space-x-4">
                    <button
                        onClick={login}
                        className="flex-1 bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 rounded-lg transition-colors"
                    >
                        Login
                    </button>
                    <button
                        onClick={loginWithWallet}
                        className="flex-1 bg-green-500 hover:bg-green-600 text-white font-semibold py-2 rounded-lg transition-colors"
                    >
                        ERC20 Wallet Login
                    </button>
                </div>
                {message && (
                    <p className="mt-4 text-center text-green-500">
                        {message}
                    </p>
                )}
            </div>
        </div>
    );
}

export default LoginForm;
